$hyoo_budget_app $mol_book2_catalog
	param \fund
	menu_title @ \Funds
	menu_tools /
		<= Profile_link $mol_link
			hint @ \Profile
			arg *
				profile <= person_id \
				fund null
			sub /
				<= Profile_icon $mol_icon_account
		<= Fund_make $mol_button_minor
			hint @ \New fund
			click? <=> fund_make? null
			sub /
				<= Fund_make_icon $mol_icon_plus
	Menu_links_empty $mol_status title @ \Add new fund ⤴️
	menu_foot /
		<= Sources $mol_link_source
			uri \https://github.com/hyoo-ru/budget.hyoo.ru/
		<= Status $hyoo_crus_status
		<= Lang $mol_select
			value? <=> lang? \en
			dictionary *
				ru \RU
				en \EN
		<= Lights $mol_lights_toggle
	Spread* <= Fund_page* $hyoo_budget_fund_book
		fund <= fund* $hyoo_budget_fund
		menu_addon /
			<= Spread_close
		visible? <=> fund_visible*? true
	Spread_default $hyoo_budget_intro
	plugins /
		<= Theme $mol_theme_auto
	Profile_page* $hyoo_budget_person_page
		close_arg *
			profile null
		person <= profile* $hyoo_budget_person
	Placeholder null
